import React, { useState, useEffect } from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";

const SpinnerFullScreen = () => {
  return (
    <div className="full-screen-spinner-container">
        <div className="loading-spinner">
      </div>
    </div>
  );
};

export default SpinnerFullScreen;
